import { MessageBar, MessageBarType } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import { Stack, ValidationFailure, ValidationResult } from "sprint-common-web";

import { EncodeSpecificationContentType } from "../../../../common/types/EncodeSpecificationContentType";
import { SystemPlatformValidationRequest, systemPlatformValidator } from "../../SystemPlatformValidator";
import { SystemPlatformDetailsContext } from "../context/SystemPlatformDetailsContext";

export const SystemPlatformDetailsValidationSection: React.VFC = () => {
    const [failures, setFailures] = useState<ValidationFailure[]>([]);
    const { systemPlatformDetailsItem } = useContext(SystemPlatformDetailsContext);
    const validator = systemPlatformValidator();

    useEffect(() => {
        if (systemPlatformDetailsItem.system.id) {
            syncFailures();
        }
    }, [systemPlatformDetailsItem]);

    const syncFailures = () => {
        const validationResult = validateSystemPlatformDetails();

        setFailures(validationResult.failures);
    };

    const validateSystemPlatformDetails = (): ValidationResult => {
        const movieSpecification = systemPlatformDetailsItem.specifications.find(
            (item) => item.encodeSpecificationContentType === EncodeSpecificationContentType.Movie
        );
        const tvSpecification = systemPlatformDetailsItem.specifications.find(
            (item) => item.encodeSpecificationContentType === EncodeSpecificationContentType.TvSeries
        );

        const validationItem: SystemPlatformValidationRequest = {
            audioProxyType: systemPlatformDetailsItem.encodeConfiguration.audioProxyType,
            muxSubtitleType: systemPlatformDetailsItem.encodeConfiguration.muxSubtitleType,
            copySubtitleType: systemPlatformDetailsItem.encodeConfiguration.copySubtitleType,
            muxSpecificationId: systemPlatformDetailsItem.encodeConfiguration.muxSpecification?.id,
            deliveryEndpoint: systemPlatformDetailsItem.deliveryInfo.deliveryEndpoint,
            buzzIds: systemPlatformDetailsItem.buzzIds,
            shreqIds: systemPlatformDetailsItem.shreqIds,
            movieSpecificationId: movieSpecification?.defaultEncodeSpecificationId,
            tvSpecificationId: tvSpecification?.defaultEncodeSpecificationId
        };

        return validator.validate(validationItem);
    };

    return (
        <Stack style={{ padding: 10 }}>
            {failures.map((item) => (
                <MessageBar key={item.code} messageBarType={MessageBarType.warning}>
                    {
                        <>
                            {item.message}
                            <br />
                        </>
                    }
                </MessageBar>
            ))}
        </Stack>
    );
};
